import { MapStoreState } from '@redux/map/map-reducer';
import { LayerTypes, SourceItem } from '@redux/map/types';
import { createFeatureCollection } from '@utils/mapUtils';
import { SimulationState } from '@api/entities/replancity_RunnedAlgorithm';

export const createSource = (state: MapStoreState, source: SourceItem) => {
    const { id, calculationState, group } = source;

    state.sources.byId[id] = source;
    state.sources.allId.push(id);
    state.dataBySourceId[id] = createFeatureCollection();
    if (calculationState) {
        state.calculationStateBySourceId[id] = calculationState as SimulationState;
    }
    state.requireToReloadSources[id] = false;

    if (!state.layersGroups.includes(group)) {
        state.layersGroups = [...state.layersGroups, group];
    }
};

export const addLayer = (state: MapStoreState, layer: LayerTypes, position: 'top' | 'bottom') => {
    const { id, layerType, source } = layer;
    state[layerType].byId[id] = layer;

    if (position === 'bottom') {
        state[layerType].allId.push(id);
    } else if (position === 'top') {
        state[layerType].allId.unshift(id);
    }

    if (!state.allLayersIdsBySourceId[source]) {
        state.allLayersIdsBySourceId[source] = [];
    }
    state.allLayersIdsBySourceId[source].push(id);
};
